import { Tooltip, Collapse } from 'bootstrap/dist/js/bootstrap.bundle';

export const initBootstrapComponents = () => {
    // Initialize tooltips
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    [...tooltipTriggerList].map(tooltipTriggerEl => new Tooltip(tooltipTriggerEl));

    // Initialize collapse
    const collapseElementList = document.querySelectorAll('.collapse');
    [...collapseElementList].map(collapseEl => new Collapse(collapseEl, {
        toggle: false
    }));
};

export default initBootstrapComponents; 